var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "settings_svg__Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".settings_svg__st0{fill:#666}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "settings_svg__st0",
    d: "M30.7 23.4h-.6c-.3-.9-1.1-1.5-2.1-1.5s-1.8.6-2.1 1.5h-7.3c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.3c.3 1 1.1 1.7 2.2 1.7s1.9-.7 2.2-1.7h.5c.4 0 .7-.3.7-.7-.1-.4-.4-.7-.8-.7zM30.7 29.3h-7.3c-.3-.9-1.1-1.5-2.1-1.5s-1.8.6-2.1 1.5h-.6c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h.4c.3 1 1.1 1.7 2.2 1.7s1.9-.7 2.2-1.7h7.3c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7zM18.5 19.2h.5c.3 1 1.1 1.7 2.2 1.7s1.9-.7 2.2-1.7h7.3c.4 0 .7-.3.7-.7s-.3-.7-.7-.7h-7.3c-.3-.9-1.1-1.5-2.1-1.5s-1.8.6-2.1 1.5h-.6c-.4 0-.7.3-.7.7s.2.7.6.7z"
  })));
};
export default SvgSettings;